import { useTranslation } from 'react-i18next'
import {
  StyledSubscriptionsContainer,
  StyledSubscriptionsMiniTitle,
  StyledSubscriptionsSwiperContainer,
  StyledTabContentTitle,
} from './styles'
import { SubscriptionsSwiper } from './SubscriptionsSwiper'
import {
  SeasonTicket,
  useGetSeasonTicketsQuery,
} from 'store/api-slices/userSlice'
import { useEffect, useState } from 'react'
import { Loader } from 'shared/components/loader/loader'
import { Typography } from '@mui/material'
import EmptyState from '../../empty-state/EmptyState'

type SubscriptionsDetails = [
  { title: 'mySubscription'; data: SeasonTicket[] },
  { title: 'additionalSubscriptions'; data: SeasonTicket[] },
  { title: 'pastSubscriptions'; data: SeasonTicket[] },
]

export const Subscriptions = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.subscriptions',
  })

  const [seasonTickets, setSeasonTickets] = useState<SubscriptionsDetails>([
    { title: 'mySubscription', data: [] },
    { title: 'additionalSubscriptions', data: [] },
    { title: 'pastSubscriptions', data: [] },
  ])

  const { data, isLoading, error } = useGetSeasonTicketsQuery()

  useEffect(() => {
    if (data) {
      setSeasonTickets([
        { title: 'mySubscription', data: data.currentOwnerSeasonTickets },
        {
          title: 'additionalSubscriptions',
          data: data.seasonTicketsPurchaserAccountByPersonAccountId,
        },
        { title: 'pastSubscriptions', data: data.pastOwnerSeasonTickets },
      ])
    }
  }, [data])

  if (isLoading) return <Loader isLoading={isLoading} />
  if (error) {
    return <Typography color="error">Error loading subscriptions.</Typography>
  }
  if (
    seasonTickets.every(
      (seasonTicketSection) => seasonTicketSection.data.length === 0,
    )
  ) {
    return <EmptyState />
  }

  return (
    <StyledSubscriptionsContainer>
      <StyledTabContentTitle>{t('text')}</StyledTabContentTitle>
      {seasonTickets.map((seasonTicket) =>
        seasonTicket.data.length ? (
          <div key={seasonTicket.title}>
            <StyledSubscriptionsMiniTitle>
              {t(`${seasonTicket.title}`)}
            </StyledSubscriptionsMiniTitle>
            <StyledSubscriptionsSwiperContainer>
              <SubscriptionsSwiper subscriptions={seasonTicket.data} />
            </StyledSubscriptionsSwiperContainer>
          </div>
        ) : null,
      )}
    </StyledSubscriptionsContainer>
  )
}
